import { Container } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./style.scss";
import { useEffect } from "react";
import { StorageKEY } from "../../models";
const NotFoundPage = () => {
  useEffect(() => {
    localStorage.setItem(StorageKEY.reloadBooking, JSON.stringify(false));
  }, []);
  return (
    <div className="page notfound">
      <div className="page-inner">
        <Container>
          <p className="number-404">404</p>
          <p>Nội dung bạn tìm kiếm không tồn tại, vui lòng trở lại trang chủ</p>
          <Link to="/">Về trang chủ</Link>
        </Container>
      </div>
    </div>
  );
};
export default NotFoundPage;
